import { render, staticRenderFns } from "./EnacAtplDashboardItemLearnerComments.vue?vue&type=template&id=225614ba"
import script from "./EnacAtplDashboardItemLearnerComments.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardItemLearnerComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports